const STORAGE_KEY = 'headerAlertClosed';

const isHeaderAlertClosed = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
};

const markHeaderAlertAsClosed = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch (error) {
    // Brak dostępu do sessionStorage – pasek wróci po przeładowaniu strony.
  }
};

export const initHeaderAlert = () => {
  const alertElement = document.querySelector('[data-js-header-alert-dismissed]');
  if (!alertElement) return;

  if (isHeaderAlertClosed()) {
    alertElement.remove();
    return;
  }

  alertElement.classList.remove('d-none');
};

export const headerAlertEvents = [
  // closed.bs.alert odpala się po usunięciu elementu z DOM, więc nie dociera do delegacji na document.
  ['jsHeaderAlertDismissed', markHeaderAlertAsClosed, 'close.bs.alert'],
];
